import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
// import PageHeadingWrapper from 'components/PageHeadingWrapper';

const StyledOrdersPageHeading = styled(FullWidthPageContent)` //(PageHeadingWrapper)
  color: ${({ theme }) => theme.palette.primary.contrastText};
  background-color: ${({ theme }) => theme.palette.background.primary};
  padding: ${({ theme }) => theme.spacing * 2}px;
`;

const OrdersPageHeading = ({ className }) => {
  const classes = ['OrdersPageHeading', className];

  return (
    <StyledOrdersPageHeading className={classes.filter((c) => !!c).join(' ')}>
      <h1>Orders &amp; payments</h1>
      <p>Tap an order to view or make changes to a delivery</p>
    </StyledOrdersPageHeading>
  );
};

OrdersPageHeading.displayName = 'OrdersPageHeading';

OrdersPageHeading.propTypes = {
  className: PropTypes.string,
};

OrdersPageHeading.defaultProps = {
  className: null,
};

export default OrdersPageHeading;
